'use client'

import { useTranslations } from 'next-intl'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'

export const Error = ({ name }: { name: string }) => {
  const {
    formState: { errors },
  } = useFormContext()
  const t = useTranslations('Forms')
  return (
    <div
      className="mt-2 text-red-500 text-sm"
      id={`${name}-error`}
      role="alert"
      aria-live="polite"
    >
      {(errors[name]?.message as string) || t('fieldRequired')}
    </div>
  )
}
